import { render, staticRenderFns } from "./access-denied.vue?vue&type=template&id=577734b2"
import script from "./access-denied.vue?vue&type=script&lang=js"
export * from "./access-denied.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports